// extracted by mini-css-extract-plugin
export var input = "input-module--input--Oxdkk";
export var labelText = "input-module--label-text--UE9lj";
export var textarea = "input-module--textarea--frLbO";